import BlockObject from "./BlockObject";

export default class GenericBlockObject extends BlockObject{

    constructor(blockType: OrganizationType, initialBlockObj: IBlockObj | undefined) {
        super(blockType, initialBlockObj);
        this.setAttributes(initialBlockObj);
    }
}
